
<!-- Android-->
<div *ngIf="isAndroid === c1_android">
  <div class="card p-0 m-0">
    <img [src]="theme?.emptyImageTop" class="card-img" alt="empty">
    <div class="card-img-overlay p-0">
  <div class="row p-3 d-flex align-items-center justify-content-center" [ngStyle]="bgColor">
    <div class="col-1">
      <i class="dripicons dripicons-menu responsave-font-size_xl" [ngStyle]="burgerColor"></i>
    </div>
    <div class="col-7">
      <p class="card-title mb-0 text-truncate responsave-font-size_xl "
        style="max-width: 95%;" [ngStyle]="appNameColor" >{{channel_name}}
      </p>
    </div>
    <div class="col-1">
      <i class="fas fa-search responsave-font-size_xl" [ngStyle]="otherTextColor"></i>
    </div>
    <div class="col-1">
      <i class="fas fa-bell responsave-font-size_xl" [ngStyle]="otherTextColor"></i>
    </div>
    <div class="col-1">
      <i class="fas fa-ellipsis-v responsave-font-size_xl" [ngStyle]="otherTextColor"></i>
    </div>
  </div>
    </div>
  </div>
</div>

<!-- IOS Small Title -->
<div *ngIf="isAndroid === c1_ios && (isLarge !== c7_Large || isComponent)">
  <div class="card p-0 m-0  ">
    <img [src]="theme?.emptyImageTop" class="card-img" alt="empty">
    <div class="card-img-overlay p-0 m-0">
      <div class="row p-2" >
        <div class="col-2">
          <i *ngIf="isback" class="fas fa-angle-left font-size-14 responsave-font-size_xl" [ngStyle]="TopBarTextColor"></i>
        </div>
        <div class="col-8">
          <p class="responsave-font-size_xl fw-bold text-black text-center"> {{ title }}</p>
        </div>

        <div class="col-2">

        </div>
      </div>
    </div>
  </div>
</div>

<!-- IOS Large Title -->
<div *ngIf="isAndroid === c1_ios && isLarge === c7_Large && !isComponent ">
  <div class="card p-0 m-0  ">
    <img [src]="theme?.emptyImageTop" class="card-img" alt="empty">
    <div class="card-img-overlay p-0 m-0">
      <div class="row p-2" >
        <div class="col-2">
          <i *ngIf="isback" class="fas fa-angle-left font-size-14 responsave-font-size_xl" [ngStyle]="TopBarTextColor"></i>
        </div>
        <div class="col-8">
        </div>
        <div class="col-2">
        </div>
      </div>

      <!-- <div class="row p-5" >
        <p class="fs-6 fw-bolder text-black text-center"> {{ title }}</p>
      </div> -->
    </div>
  </div>
  <div *ngIf="isLarge === c7_Large">
    <div class="card p-0 m-0">
      <img [src]="theme?.emptyImageTitle" class="card-img" alt="empty">
      <div class="card-img-overlay m-0 p-0">
        <div class="row ps-3 p-0 align-text-middle">
          <p class="fw-bolder fs-4 text-black pb-2">  {{ title }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
